import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type Props = {
  open: boolean;
  onClose: () => void;
};
export function ImpressumModal({
  open,
  onClose
}: Props) {
  useEffect(() => {
    if (!open) return;
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handler);
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', handler);
      document.body.style.overflow = '';
    };
  }, [open, onClose]);
  return <AnimatePresence data-id="element-140">
      {open && <motion.div className="fixed inset-0 z-50 flex items-center justify-center p-4 md:p-8" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} data-id="element-141">
          {/* Backdrop */}
          <motion.div className="absolute inset-0 bg-petrol-dark/80 backdrop-blur-sm" onClick={onClose} initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} data-id="element-142" />

          {/* Modal */}
          <motion.div role="dialog" aria-modal="true" aria-labelledby="impressum-title" className="relative w-full max-w-2xl max-h-[85vh] overflow-y-auto bg-white rounded-lg shadow-2xl" initial={{
        opacity: 0,
        y: 20,
        scale: 0.98
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.98
      }} transition={{
        duration: 0.25,
        ease: 'easeOut'
      }} data-id="element-143">
            {/* Header */}
            <div className="sticky top-0 flex items-center justify-between px-8 py-6 bg-white border-b border-slate-100" data-id="element-144">
              <div className="flex items-center gap-4" data-id="element-145">
                <div className="h-px w-8 bg-hoefelmeyer-green" data-id="element-146"></div>
                <h2 id="impressum-title" className="text-2xl font-extrabold text-petrol tracking-tight" data-id="element-147">
                  Impressum
                </h2>
              </div>
              <button type="button" onClick={onClose} aria-label="Schließen" className="w-9 h-9 flex items-center justify-center rounded-full text-slate-500 hover:text-petrol hover:bg-slate-100 transition-colors" data-id="element-148">
                <XIcon size={20} strokeWidth={1.5} data-id="element-149" />
              </button>
            </div>

            {/* Content */}
            <div className="px-8 py-8 space-y-8 text-slate-700 text-sm leading-relaxed font-light" data-id="element-150">
              <section data-id="element-151">
                <h3 className="text-base font-bold text-petrol mb-3" data-id="element-152">
                  Anschrift
                </h3>
                <p data-id="element-153">
                  Höfelmeyer Waagen GmbH
                  <br data-id="element-154" />
                  Werner-von-Siemens-Straße 33
                  <br data-id="element-155" />
                  DE-49124 Georgsmarienhütte
                </p>
              </section>

              <section data-id="element-156">
                <h3 className="text-base font-bold text-petrol mb-3" data-id="element-157">
                  Kontakt
                </h3>
                <p data-id="element-158">
                  <span className="text-slate-500 w-20 inline-block" data-id="element-159">Tel:</span>
                  +49 5401 4977 0
                </p>
                <p data-id="element-160">
                  <span className="text-slate-500 w-20 inline-block" data-id="element-161">
                    E-Mail:
                  </span>
                  waagen(at)hoefelmeyer.de
                </p>
              </section>

              <section data-id="element-162">
                <h3 className="text-base font-bold text-petrol mb-3" data-id="element-163">
                  Geschäftsführer
                </h3>
                <p data-id="element-164">
                  Felix Höfelmeyer
                  <br data-id="element-165" />
                  Viktor Rempe
                </p>
              </section>

              <section data-id="element-166">
                <h3 className="text-base font-bold text-petrol mb-3" data-id="element-167">
                  Registereintrag
                </h3>
                <p data-id="element-168">
                  Handelsregister Amtsgericht: HRB 110826
                  <br data-id="element-169" />
                  Amtsgericht Osnabrück
                </p>
                <p className="mt-3" data-id="element-170">
                  <span className="text-slate-500 w-32 inline-block" data-id="element-171">
                    USt.-IdNr.:
                  </span>
                  DE 117651615
                </p>
                <p data-id="element-172">
                  <span className="text-slate-500 w-32 inline-block" data-id="element-173">
                    Steuernummer:
                  </span>
                  65/200/61356
                </p>
              </section>

              <section data-id="element-174">
                <h3 className="text-base font-bold text-petrol mb-3" data-id="element-175">
                  Inhaltlich Verantwortlicher gemäß
                  Digitale-Dienste-Gesetz&nbsp;(DDG)
                </h3>
                <p data-id="element-176">
                  Höfelmeyer Waagen GmbH
                  <br data-id="element-177" />
                  Werner-von-Siemens-Straße 33
                  <br data-id="element-178" />
                  49124 Georgsmarienhütte
                </p>
                <p className="mt-3" data-id="element-179">
                  vertreten durch den Geschäftsführer Felix Höfelmeyer
                </p>
                <p className="mt-3" data-id="element-180">
                  <span className="text-slate-500 w-20 inline-block" data-id="element-181">Tel:</span>
                  +49 5401 4977 0
                </p>
                <p data-id="element-182">
                  <span className="text-slate-500 w-20 inline-block" data-id="element-183">
                    E-Mail:
                  </span>
                  waagen(at)hoefelmeyer.de
                </p>
              </section>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}